<template>
  <div class="content">
    <h1>笛子转调表</h1>

    <div class="row">
      <div class="col s3">
        <p class="label">选笛子</p>
      </div>
      <div class="col s9">
        <div class="input-field">
          <select v-model="diao" v-on:change="updateList(diao)">
            <option v-for="item in ori_keys">{{item}}</option>
          </select>
          <label>{{diao}} 调笛子</label>
        </div>
      </div>
    </div>
    

    <h5><b>{{ diao }}调</b> 笛子的转调表:</h5>
    <ul class="collection">
      <li v-for="item in diaoList" class="collection-item">
        筒音作 <b>{{ item[0] }}</b>  
        <span> <b>{{ item[1] }}</b> 调</span>
      </li>
    </ul>

  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      ori_keys: ['C', 'D', 'E', 'F', 'G', 'A', 'B', '降B', '降E', '升F', '降D', '降A'],
      keys: ['C', 'G', 'D', 'A', 'E', 'B', '升F', '降D', '降A', '降E', '降B', 'F'],
      tongyin: [7, 3, 6, 2, 5, 1, 4],
      tongyin_ordered: [5, 2, 1, 6, 3, 4, 7],
      
      diao: "C",
      diaoList: []
    }
  },
  methods: {
    getKey: function (index) {
      index = (index + this.keys.length) % this.keys.length;
      return this.keys[index];
    },
    shiftKeys: function(key) {
      while (this.keys[0] != key) {
        this.keys.push(this.keys.shift());
      }
    },
    getZhuangDiaoList: function (key) {
      var result_map = {};
      this.shiftKeys(key);
      for (var i=-4; i<=2; i++) {
        var tongyin = this.tongyin[i + 4];
        var diao = this.getKey(i);
        result_map[tongyin] = diao;
      }

      var result_list = [];
      for (var i=0; i<this.tongyin_ordered.length; i++) {
        var tongyin = this.tongyin_ordered[i]; 
        var diao = result_map[tongyin];
        result_list.push( [tongyin, diao] );
      }
      return result_list;
    },
    updateList: function(key) {
      this.diaoList = this.getZhuangDiaoList(this.diao);
    }
  },
  created() {
    this.diaoList = this.getZhuangDiaoList(this.diao);
    document.addEventListener('DOMContentLoaded', function() {
      var elems = document.querySelectorAll('select');
      var instances = M.FormSelect.init(elems, {});
    });
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .content {
    margin: 0 5% 20% 5%;
  }
  .content h1 {
    font-size: 35px;
    text-align: center;
  }
  .content ul li {
    padding-left: 20%;
  }
  .content ul li:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
  .content ul li span {
    margin-left: 25%;
  }
  p.label {
    font-size: 17px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue